import * as React from 'react';
import type { INavigation } from '../../types';
import FooterLink from '../Link/Link';

interface INavigationProps {
  navigation: INavigation[] | null;
}

const Navigation = ({ navigation }: INavigationProps) => {
  if (!navigation) {
    return null;
  }

  return (
    <div className={'footer__navigation row d-flex justify-content-between align-items-start'}>
      {navigation.map(({ title, nodes }, nodeIndex) => (
        <nav
          key={`navigation-${title}-${nodeIndex}`}
          className={'footer__navigation__item col-6 col-md-4 col-lg'}
        >
          <h6 className="headline">{title}</h6>
          <ul>
            {nodes &&
              nodes.map((navItem, itemIndex) => (
                <li key={`link-${(navItem.page && navItem.page.name) || navItem.title}-${itemIndex}`}>
                  <FooterLink to={navItem.page && navItem.page.url ? navItem.page.url : navItem.link}>
                    {(navItem.page && navItem.page.name) || navItem.title}
                  </FooterLink>
                </li>
              ))}
          </ul>
        </nav>
      ))}
    </div>
  );
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Footer/components/Navigation/Navigation.tsx